const formatNumber = amount => Intl.NumberFormat().format(amount);

export { formatNumber };
